@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.ss-settings-modal-body {
  padding: 16px 20px 40px;
  height: 100%;
}

.name-input {
  padding: 10px 0 20px;
  width: 360px;
}

.loading-indicator {
  height: 100px;
}
